import VoteChoiceSearch from './VoteChoiceSearch.vue'
import VoteCascadeSearch from './VoteCascadeSearch.vue'
import { getComponentFactory } from 'dygc'

const getComponent = getComponentFactory({ VoteChoiceSearch, VoteCascadeSearch });

export default {
  props:{
    question:Object
  },
  render(h){
    const Comp = getComponent(this.question.questionType)
    return h(Comp, {
      ref: 'root',
      scopedSlots: this.$scopedSlots,
      props: { ...this.$attrs,question: this.question },
      on: { ...this.$listeners },
      key: this.question.q_id
    })
  }
}